import React, { memo, useState, useCallback } from "react";
import { Text } from "@shopify/polaris";
import { ArrowDownIcon, ArrowUpIcon } from "@shopify/polaris-icons";

const FAQ_ITEMS = [
  {
    q: "Does AgeShield work with all Shopify themes?",
    a: "Yes. AgeShield uses a theme app embed, so it works with most Online Store 2.0 themes and many custom themes. If your popup does not appear, enable the app embed in Theme editor and save.",
  },
  {
    q: "How do I activate or disable the age popup?",
    a: "Open Theme editor from Dashboard and toggle the AgeShield app embed. Enable to show verification popup on storefront, or disable to hide it.",
  },
  {
    q: "Can I create different age rules for different countries?",
    a: "Yes. Create country-specific templates from Settings, and AgeShield will apply the matching template by visitor country with your configured language and minimum age.",
  },
  {
    q: "Why does analytics show low or zero verification counts?",
    a: "Analytics is based on verification events. Counts stay low when app embed is disabled, date range filter is narrow, or there is low storefront traffic in the selected period.",
  },
  {
    q: "Does AgeShield support checkout verification too?",
    a: "Yes. You can configure checkout verification in template settings and choose where to run it. Make sure checkout settings are saved for the template you want to enforce.",
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = useCallback((idx) => {
    setOpenIndex((prev) => (prev === idx ? -1 : idx));
  }, []);

  return (
    <div className="age-faq-section">
      <Text as="h2" variant="headingLg">
        Frequently Ask Questions
      </Text>

      <div className="age-faq-list">
        {FAQ_ITEMS.map((item, idx) => {
          const open = openIndex === idx;
          return (
            <div key={item.q} className={`age-faq-item${open ? " age-faq-item--open" : ""}`}>
              <button
                type="button"
                className="age-faq-item__btn"
                onClick={() => toggle(idx)}
                aria-expanded={open}
              >
                <Text as="span" variant="bodyMd">
                  {idx + 1}. {item.q}
                </Text>
                <span className="age-faq-item__icon" aria-hidden>
                  {open ? <ArrowUpIcon /> : <ArrowDownIcon />}
                </span>
              </button>
              {open ? (
                <div className="age-faq-item__answer">
                  <Text as="p" variant="bodySm" tone="subdued">
                    {item.a}
                  </Text>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default memo(FaqSection);
